/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SelectTextField.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";


function SelectTextField({
  size,
  defaultvalue,
  label,
  variant,
  required,
  disabled,
  optionsList,
  selectedValue,
  setSelectedValue,
  sltFldStyle,
}) {
  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: 48 * 4.5 + 8,
        width: 220,
        overflowX: "auto", // Allow horizontal scrolling
        // whiteSpace: "nowrap", // Prevent text from wrapping to the next line
        overflowX: "hidden", // Hide horizontal overflow
        scrollbarWidth: "thin", // Firefox
        msOverflowStyle: "none", // IE and Edge
        "&::-webkit-scrollbar": {
          height: "8px", // Adjust scrollbar height
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "#888", // Scrollbar thumb color
          borderRadius: "4px", // Scrollbar thumb rounded corners
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "#f1f1f1", // Scrollbar track color
        },
      },
    },
  };

  // Handles change events when a new value is selected from the dropdown.
  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  return (
    <FormControl
      variant={variant}
      fullWidth
      size={size}
      required={required}
      sx={sltFldStyle}
    >
      <InputLabel>{label}</InputLabel>
      <Select
        disabled={disabled}
        value={selectedValue}
        onChange={handleChange}
        MenuProps={menuProps}
      >
        {optionsList?.map((option) => (
          <MenuItem
            key={option?.value}
            value={option?.value}
            sx={{
              whiteSpace: "normal",
              wordBreak: "break-word",
              lineHeight: 1.5,
            }}
          >
            {option?.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectTextField;
